import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Resenas from '../components/Resenas';
import MarcasProveedores from '../components/MarcasProveedores';
import BannerCarrusel from '../components/BannerCarrusel';

const API = process.env.REACT_APP_API_URL || '/api';

const TICKER_DEFAULT = ['🚗 Servicio a domicilio','⏰ Atención Personalizada','🛡️ Garantía incluida','📦 Amplio Stock','⚡ Instalación profesional','🔋 Todas las marcas','🚚 Rescate en carretera','📞 Llámenos ya'];

export default function Inicio() {
  const [categorias, setCategorias] = useState([]);
  const [servicios, setServicios] = useState([]);
  const [productos, setProductos] = useState([]);
  const [visible, setVisible] = useState(false);
  const [ticker, setTicker] = useState<{velocidad: number; mensajes: string[]}>({velocidad: 20, mensajes: TICKER_DEFAULT});

  useEffect(() => {
    setTimeout(() => setVisible(true), 100);
    axios.get(`${API}/categorias/`).then(r => setCategorias(r.data)).catch(() => {});
    axios.get(`${API}/servicios/`).then(r => setServicios(r.data)).catch(() => {});
    axios.get(`${API}/productos/`).then(r => setProductos(r.data.slice(0, 3))).catch(() => {});
    axios.get(`${API}/ticker/`).then(r => { if (r.data?.mensajes?.length) setTicker(r.data); }).catch(() => {});
  }, []);

  return (
    <main>
      {/* BANNER SUPERIOR */}
      <BannerCarrusel posicion="superior" />

      {/* STRIP */}
      <div className="bg-rojo py-3 overflow-hidden relative">
        <div style={{display:'flex',animation:`ticker ${ticker.velocidad}s linear infinite`,whiteSpace:'nowrap'}}>
          {ticker.mensajes.concat(ticker.mensajes).map((item, i) => (
            <span key={i} className="text-white text-xs font-bold tracking-wider flex-shrink-0" style={{paddingLeft:'48px'}}>
              {item} <span style={{marginLeft:'48px',opacity:0.5}}>◆</span>
            </span>
          ))}
        </div>
      </div>

      {/* HERO */}
      <section className="relative bg-azul min-h-[580px] flex items-center overflow-hidden">
        <div className="absolute inset-0" style={{backgroundImage:'repeating-linear-gradient(45deg,rgba(255,255,255,0.03) 0,rgba(255,255,255,0.03) 1px,transparent 0,transparent 50%)',backgroundSize:'24px 24px'}}/>
        <div className="absolute -right-20 -top-20 w-96 h-96 bg-rojo/10 rounded-full blur-3xl"/>
        <div className="absolute -left-20 -bottom-20 w-80 h-80 bg-white/5 rounded-full blur-3xl"/>
        <div className="max-w-7xl mx-auto px-4 py-20 grid md:grid-cols-2 gap-12 items-center relative z-10">
          <div style={{opacity:visible?1:0,transform:visible?'translateY(0)':'translateY(30px)',transition:'all 0.8s ease'}}>
            <div className="flex items-center gap-3 mb-6">
              <span className="bg-rojo text-white text-xs font-black px-4 py-2 rounded-sm tracking-widest">⚡ SERVICIO A DOMICILIO</span>
              <span className="text-white/40 text-xs tracking-wider">COSTA RICA</span>
            </div>
            <h1 className="font-condensed font-black text-white leading-none mb-2" style={{fontSize:'clamp(52px,8vw,88px)'}}>PURA</h1>
            <h1 className="font-condensed font-black text-white leading-none mb-2" style={{fontSize:'clamp(72px,10vw,120px)'}}>⚡</h1>
            <h1 className="font-condensed font-black text-rojo leading-none mb-8" style={{fontSize:'clamp(52px,8vw,88px)'}}>ENERGÍA</h1>
            <p className="text-white/65 text-base mb-10 leading-relaxed max-w-md">
              Baterías para <strong className="text-white font-semibold">carros, motos, camiones</strong> y más.<br/>
              Instalación a domicilio en <strong className="text-white font-semibold">todo el GAM</strong>.
            </p>
            <div className="flex gap-4 flex-wrap">
              <Link to="/catalogo" className="bg-rojo text-white px-8 py-4 rounded-full font-black text-sm tracking-wider hover:bg-rojo-dark transition-all hover:scale-105 shadow-lg shadow-rojo/30 flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="white"><path d="M6 2a1 1 0 0 0-1 1v1H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1V3a1 1 0 1 0-2 0v1H7V3a1 1 0 0 0-1-1z"/></svg>
                VER CATÁLOGO
              </Link>
              <a href="https://wa.me/50685076464" target="_blank" rel="noreferrer" className="bg-[#25D366] text-white px-8 py-4 rounded-full font-black text-sm tracking-wider hover:bg-[#20ba5a] transition-all hover:scale-105 flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="white"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                WHATSAPP
              </a>
            </div>
            <div className="flex gap-6 mt-10 flex-wrap">
              {['✓ Instalación Profesional','✓ Garantía por escrito','✓ Calidad Premium'].map(t => (
                <span key={t} className="text-white/50 text-xs font-medium tracking-wide">{t}</span>
              ))}
            </div>
          </div>
          <div style={{opacity:visible?1:0,transform:visible?'translateX(0)':'translateX(40px)',transition:'all 0.9s ease 0.2s'}} className="hidden md:grid grid-cols-2 gap-4">
            {[
              {num:'🚗', lab:'SERVICIO A DOMICILIO', color:'bg-rojo', shadow:'shadow-rojo/40'},
              {num:'+5000', lab:'CLIENTES FELICES', color:'bg-white/10', shadow:''},
              {num:'GAM', lab:'RESCATE EN CARRETERA', color:'bg-white/10', shadow:''},
              {num:'📦', lab:'AMPLIO STOCK', color:'bg-azul-light/50', shadow:''},
            ].map((s,i) => (
              <div key={i} style={{opacity:visible?1:0,transform:visible?'translateY(0)':'translateY(20px)',transition:`all 0.6s ease ${0.3+i*0.1}s`}}
                className={`${s.color} border border-white/15 rounded-2xl p-6 text-center backdrop-blur-sm ${s.shadow&&`shadow-xl ${s.shadow}`}`}>
                <div className="font-condensed text-5xl font-black text-white mb-1">{s.num}</div>
                <div className="text-white/55 text-xs tracking-widest font-semibold">{s.lab}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-rojo to-transparent"/>
      </section>

      {/* CATEGORÍAS */}
      <section className="bg-gray-50 py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <div className="text-rojo text-xs font-bold tracking-widest mb-2">CATEGORÍAS</div>
            <h2 className="font-condensed text-5xl font-black text-azul">Baterías y Accesorios para todos</h2>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
            {(categorias.length > 0 ? categorias : [
              {id:1, icono:'🚗', nombre:'Automóviles', descripcion:'Sedán, SUV, coupé, pickup'},
              {id:2, icono:'🏍️', nombre:'Motocicletas', descripcion:'Todo tipo y marca'},
              {id:3, icono:'🚛', nombre:'Pesados', descripcion:'Camiones y carga pesada'},
              {id:4, icono:'⚡', nombre:'Especiales', descripcion:'Solar, UPS, silla de ruedas'},
            ] as any[]).map((c: any) => (
              <Link to={`/catalogo?categoria=${c.id}`} key={c.id}
                className="bg-white border-2 border-gray-100 rounded-2xl p-8 text-center hover:border-azul hover:shadow-xl hover:-translate-y-2 transition-all duration-300 group">
                {c.icono_url ? <img src={`https://ticobaterias.com${c.icono_url}`} alt={c.nombre} className='w-14 h-14 mx-auto mb-4 object-contain group-hover:scale-110 transition-transform duration-300'/> : <span className='text-5xl block mb-4 group-hover:scale-110 transition-transform duration-300'>{c.icono || '🔋'}</span>}
                <div className="font-condensed text-xl font-black text-azul">{c.nombre}</div>
                <div className="text-gray-400 text-xs mt-2 leading-relaxed">{c.descripcion}</div>
                <div className="mt-4 text-rojo text-xs font-bold opacity-0 group-hover:opacity-100 transition-opacity">Ver productos →</div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* SERVICIOS */}
      <section className="bg-white py-20 px-4">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-16 items-start">
          <div>
            <div className="text-rojo text-xs font-bold tracking-widest mb-3">SERVICIOS</div>
            <h2 className="font-condensed text-5xl font-black text-azul mb-8 leading-tight">El servicio<br/>nos complementa</h2>
            <div className="space-y-4">
              {(servicios.length > 0 ? servicios : [
                {id:1, nombre:'🔍 Diagnóstico y Revisión', descripcion:'Diagnóstico de voltaje y estado de la batería.'},
                {id:2, nombre:'🔧 Venta e Instalación', descripcion:'Para todo tipo de vehículo.'},
                {id:3, nombre:'🚚 Servicio Domicilio y Encomienda', descripcion:'Coordinamos para hacer una entrega efectiva.'},
                {id:4, nombre:'🤝 Servicio Posventa', descripcion:'Resolvemos tus dudas y te damos asesoría.'},
              ] as any[]).map((s: any, i: number) => (
                <div key={s.id} className={`bg-gray-50 rounded-2xl p-6 border-l-4 ${i%2===0?'border-azul':'border-rojo'} hover:translate-x-2 hover:shadow-md transition-all duration-300`}>
                  <div className="font-condensed text-xl font-black text-azul mb-2">{s.nombre}</div>
                  <div className="text-gray-500 text-sm leading-relaxed">{s.descripcion}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="bg-azul rounded-3xl p-10 relative overflow-hidden">
            <div className="absolute -top-16 -right-16 w-56 h-56 bg-white/5 rounded-full"/>
            <div className="absolute -bottom-16 -left-16 w-64 h-64 bg-rojo/15 rounded-full"/>
            <div className="relative z-10">
              <span className="bg-rojo text-white text-xs font-black px-4 py-2 rounded-sm tracking-widest inline-block mb-6">⚡ DISPONIBLE AHORA</span>
              <div className="font-condensed font-black text-white leading-none mb-6" style={{fontSize:'clamp(40px,5vw,56px)'}}>
                Servicio<br/><span className="text-white/50">a Domicilio</span>
              </div>
              <p className="text-white/60 text-sm leading-relaxed mb-8">Técnicos especializados disponibles para su necesidad en Energía.</p>
              <a href="tel:+50622705060" className="bg-white text-azul font-black text-sm px-6 py-3 rounded-xl inline-flex items-center gap-2 hover:bg-gray-100 transition-colors shadow-lg">
                📞 Solicitar ahora
              </a>
            </div>
          </div>
        </div>
      </section>


      {/* PRODUCTOS */}
      <section className="bg-gray-50 py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="flex justify-between items-end mb-10">
            <div>
              <div className="text-rojo text-xs font-bold tracking-widest mb-2">CATÁLOGO</div>
              <h2 className="font-condensed text-5xl font-black text-azul">Productos destacados</h2>
            </div>
            <Link to="/catalogo" className="text-azul text-sm font-bold hover:text-rojo transition-colors tracking-wide">Ver todos →</Link>
          </div>
          <div className="grid md:grid-cols-3 gap-6">
            {(productos.length > 0 ? productos : [
              {id:1, nombre:'Batería 12V 60Ah Sedán', precio:45000, tag:'MÁS VENDIDO', color:'bg-azul'},
              {id:2, nombre:'Batería 12V 90Ah SUV / 4x4', precio:68000, tag:'OFERTA', color:'bg-rojo'},
              {id:3, nombre:'Batería AGM Start-Stop', precio:95000, tag:'PREMIUM', color:'bg-azul-light'},
            ] as any[]).map((p: any, i: number) => (
              <div key={p.id} className="bg-white border border-gray-100 rounded-2xl overflow-hidden hover:shadow-xl hover:-translate-y-2 transition-all duration-300 group">
                <div className="bg-gradient-to-br from-gray-50 to-gray-100 h-48 flex items-center justify-center text-7xl border-b border-gray-100 relative overflow-hidden">
                  {p.imagen_url
                    ? <img src={`https://ticobaterias.com${p.imagen_url}`} alt={p.nombre} className="w-full h-full object-cover"/>
                    : <span>🔋</span>
                  }
                  {p.precio_oferta && <span className="absolute top-4 left-4 fire-badge text-lg">🔥</span>}
                  <span className={`absolute top-4 ${p.precio_oferta ? 'right-4' : 'left-4'} ${p.color||'bg-azul'} text-white text-xs px-3 py-1 rounded font-black tracking-widest`}>
                    {p.tag||'BATERÍA'}
                  </span>
                </div>
                <div className="p-6">
                  <div className="font-condensed text-xl font-black text-azul mb-2 leading-tight">{p.nombre}</div>
                  {p.precio_oferta ? (
                    <div className="mb-4">
                      <div className="text-azul text-sm font-bold line-through opacity-60">₡{p.precio?.toLocaleString()}</div>
                      <div className="font-condensed text-3xl font-black text-rojo price-fire">₡{p.precio_oferta?.toLocaleString()} </div>
                    </div>
                  ) : (
                    <div className="font-condensed text-3xl font-black text-rojo mb-4">
                      ₡{p.precio?.toLocaleString()||'0'}
                      
                    </div>
                  )}
                  <a href={`https://wa.me/50685076464?text=Me interesa: ${p.nombre}`} target="_blank" rel="noreferrer"
                    className="w-full bg-azul text-white py-3 rounded-xl font-bold text-sm flex items-center justify-center gap-2 hover:bg-rojo transition-colors group-hover:bg-rojo">
                    💬 Cotizar por WhatsApp
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <MarcasProveedores />

      <Resenas />

      {/* BANNER INFERIOR */}
      <BannerCarrusel posicion="inferior" />

      {/* CTA */}
      <section className="bg-azul py-20 px-4 text-center relative overflow-hidden">
        <div className="absolute top-0 left-0 right-0 h-1 bg-rojo"/>
        <div className="absolute -left-20 top-1/2 w-80 h-80 bg-rojo/10 rounded-full blur-3xl"/>
        <div className="absolute -right-20 top-1/2 w-80 h-80 bg-white/5 rounded-full blur-3xl"/>
        <div className="relative z-10 max-w-2xl mx-auto">
          <div className="text-white/30 text-xs tracking-widest mb-4 font-bold">EMERGENCIA DE BATERÍA</div>
          <h2 className="font-condensed font-black text-white mb-4 leading-tight" style={{fontSize:'clamp(40px,6vw,64px)'}}>
            ¿Batería descargada?<br/><span className="text-rojo italic">¡Llamenos ahora!</span>
          </h2>
          <p className="text-white/55 text-base mb-10 leading-relaxed">Asesores en Energía disponibles para brindarle el mejor servicio.<br/></p>
          <div className="flex gap-4 justify-center flex-wrap">
            <a href="tel:+50622705060" className="bg-rojo text-white px-10 py-4 rounded-xl font-black text-sm tracking-wider hover:bg-rojo-dark transition-all hover:scale-105 shadow-xl shadow-rojo/30 flex items-center gap-3">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="white"><path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z"/></svg>
              LLAMAR AHORA
            </a>
            <a href="https://wa.me/50685076464" target="_blank" rel="noreferrer"
              className="bg-[#25D366] text-white px-10 py-4 rounded-xl font-black text-sm tracking-wider hover:bg-[#20ba5a] transition-all hover:scale-105 flex items-center gap-3">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="white"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
              WHATSAPP
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}
